import { useEffect, useState, useCallback } from "react";
import Lenis from "lenis";
import axios from "axios";
import { API } from "@/lib/api";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { DownloadSection } from "@/components/DownloadSection";
import { Manifesto } from "@/components/Manifesto";
import { About } from "@/components/About";
import { Faq } from "@/components/Faq";
import { Footer } from "@/components/Footer";

const DEFAULT_INFO = { available: false, download_count: 0 };

export default function Landing() {
  const [info, setInfo] = useState(DEFAULT_INFO);

  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/download/info`);
      setInfo(data);
    } catch {
      /* keep last known state */
    }
  }, []);

  useEffect(() => {
    refresh();
    const poll = setInterval(refresh, 30000);
    return () => clearInterval(poll);
  }, [refresh]);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  const handleHeroDownload = () => {
    if (info.available) {
      window.location.href = `${API}/download/file`;
      setTimeout(refresh, 2500);
    } else {
      document.getElementById("download")?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="bg-ink min-h-screen text-foreground" data-testid="landing-page">
      <Nav count={info.download_count || 0} />
      <Hero onDownload={handleHeroDownload} available={info.available} />
      <Marquee />
      <DownloadSection info={info} />
      <Manifesto />
      <About />
      <Faq />
      <Footer />
    </div>
  );
}
